import React from 'react';
import './PageTitle.css'
import Btn from './Btn';

import Add from '../../Assets/Icons/Add.svg'

const PageTitle = (props) => {
    return ( 
        <div className='PageHeader'>
            <div className='PageTitle'>
                <p className='TitleText'>
                    {props.TitleText}
                </p>
                <p className='SubText'>
                    {props.SubText}
                </p>
            </div>

            <div className={props.HeaderBtnsClass}>
                <Btn BtnText='Register Vehicle' BtnIcon={Add} BtnStyle='AddBtn' onClick={props.BtnOnClick}/>
            </div>
        </div>
        
     );
}
 
export default PageTitle;